import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=da1d1134&scoped=true&"
import script from "./HelloWorld.vue?vue&type=script&lang=js&"
export * from "./HelloWorld.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=da1d1134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1d1134",
  null
  
)

export default component.exports